var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"floatButton",staticClass:"float-info",style:({ width: _vm.itemWidth + 'px', height: _vm.itemHeight + 'px', left: _vm.left + 'px', top: _vm.top + 'px' }),on:{"click":_vm.onBtnClick}},[_c('a-button',{attrs:{"type":"primary","shape":"circle"},on:{"click":_vm.onBtnClick}},[_c('a-icon',{attrs:{"type":"plus"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }